import { Text, WarningAlert } from '@procurify/ui'

import { ContactSupportLink } from '@webapp/core/components/ContactSupportLink'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

export const BlockedCardAlert = () => {
  const intl = useProcurifyIntl()

  return (
    <WarningAlert>
      <Text>
        {intl.formatMessage(messages.blockedCardAlertText, {
          a: (text: string) => <ContactSupportLink>{text}</ContactSupportLink>,
        })}
      </Text>
    </WarningAlert>
  )
}
